import { StyledMightyFuCasino } from './style';
import { BundleProps } from 'utils/types';
import { Box } from '@mui/system';
import { MightyFuCasinoBundlePrice } from './BundlePrice';
import { EProductPriority } from 'utils/enums';
import { useEffect, useState } from 'react';
import { MightyFuMainProduct } from './Products/MainProduct';
import { MightyFuSubProduct } from './Products/SubProduct';
import { MightyFuSaleBadge } from 'components/Badge/Sale/MightyFuSaleBadge';

export const MightyFuBundle: React.FC<BundleProps> = ({
  prices,
  productList,
  backgroundSrc,
  bundleButtonTextColor,
  salePercentage = 0,
  fontFamily,
  salePercentageDisplayType,
  tooltipLoadCallback,
  tooltipOpenEventHandler,
}) => {
  const [mainProduct, setMainProduct] = useState<any>(null);
  const [subProduct, setSubProduct] = useState<any>(null);
  const [isMainFirst, setIsMainFirst] = useState<boolean>(true);

  useEffect(() => {
    let main = productList.find(
      (product) => product.priority === EProductPriority.MAIN,
    );
    const sub = productList.find(
      (product) => product.priority === EProductPriority.SUB,
    );

    if (main && sub && productList[0].priority === EProductPriority.SUB) {
      setIsMainFirst(false);

      // ACDEV-8957: Undo this PR this logic after we can have stroked for second product
      if (sub.strokedSaleQuantity) {
        main = { ...main, strokedSaleQuantity: sub.strokedSaleQuantity };
      }
    }

    setMainProduct(main);
    setSubProduct(sub);
  }, [productList, tooltipLoadCallback]);

  return (
    <StyledMightyFuCasino
      productColor={
        productList.length > 0 ? productList[0].textFontColorHex : ''
      }
      backgroundSrc={backgroundSrc}
      fontFamily={fontFamily}
      className="mighty-fu-bundle"
    >
      {salePercentage > 0 && (
        <MightyFuSaleBadge
          salePercentage={salePercentage}
          salePercentageDisplayType={salePercentageDisplayType}
        />
      )}
      {isMainFirst ? (
        <Box className={'mighty-fu-bundle__products-container'}>
          {mainProduct && (
            <MightyFuMainProduct
              mainProduct={mainProduct}
              salePercentage={salePercentage}
            />
          )}
          {subProduct && (
            <MightyFuSubProduct
              subProduct={subProduct}
              tooltipLoadCallback={tooltipLoadCallback}
              tooltipOpenEventHandler={tooltipOpenEventHandler}
            />
          )}
        </Box>
      ) : (
        <Box className={'mighty-fu-bundle__products-container'}>
          {subProduct && (
            <MightyFuSubProduct
              subProduct={subProduct}
              tooltipLoadCallback={tooltipLoadCallback}
              tooltipOpenEventHandler={tooltipOpenEventHandler}
            />
          )}
          {mainProduct && (
            <MightyFuMainProduct
              mainProduct={mainProduct}
              salePercentage={salePercentage}
            />
          )}
        </Box>
      )}
      <MightyFuCasinoBundlePrice
        prices={prices}
        bundleButtonTextColor={bundleButtonTextColor}
        fontFamily={fontFamily}
      />
    </StyledMightyFuCasino>
  );
};
